import React, { useEffect } from "react";
import BaseLayout from "layouts/base";
import RenderModules from "components/render-modules";
import ProductGallery from "components/product-gallery";
import ProductInfo from "components/product/info";
import Tabs from "components/tabs";
import ProductRichSnippet from "rich-snippets/product";
import ProductSummary from "components/product/summary";
import { calculatePercentageDiscount } from "utils/cart";
import { trackViewItem } from "analytics";
import { useCustomer, useSettings } from "hooks/useStore";
import StickyActionBar from "components/product/sticky-action-bar";

export { Head } from "components/head";

const PDP = ({ pageContext, location }) => {
	const { product, tabs, logistics, quantityConfig, settings, crawlText, previewSettings = {}, warranty, modules } = pageContext;
	const { id, title, variant, images } = product;
	const { secureCheckout, globalPdpModules, hideLogisticInfo = false } = settings;
	const { updateRecentlyViewed } = useSettings(["updateRecentlyViewed"]);
	const customer = useCustomer();

	useEffect(() => {
		trackViewItem(product, customer);
		updateRecentlyViewed(product);

		// Disable right click
		const disableRightClick = (event) => {
			event.preventDefault();
		};
		document.addEventListener("contextmenu", disableRightClick);

		return () => {
			// Clean up the event listener when the component unmounts
			document.removeEventListener("contextmenu", disableRightClick);
		};
	}, []);

	const percentageDiscount = calculatePercentageDiscount(variant.compareAtPrice, variant.price);

	const productTabs = [].concat(tabs).concat(variant?.tabs).filter(Boolean);

	return (
		<BaseLayout previewSettings={previewSettings}>
			<StickyActionBar product={product} productTabs={productTabs} />
			<div className="product-container">
				<div className="w-full">
					<ProductGallery
						className="product-gallery"
						productId={id}
						title={title}
						productImages={images || []}
						variantImages={variant?.images || []}
						percentageDiscount={percentageDiscount}
						customSort={!location?.state?.variantChanged && product.variants[0].id === variant.id}
						verticalThumbsDesktop
					/>
				</div>
				<ProductSummary product={product} sticky />
				<div className="product-info-container">
					<ProductInfo
						product={product}
						quantityConfig={quantityConfig}
						secureCheckout={secureCheckout}
						warranty={warranty}
						logistics={logistics}
					/>
				</div>
				{productTabs.length > 0 && (
					<div id="tabs" className="py-10 md:pb-20 w-full px-0 md:px-6 max-w-screen-xl mx-auto col-span-full">
						<Tabs productId={id} tabs={productTabs} crawlText={crawlText}
							logistics={!hideLogisticInfo ? logistics : null}
						/>
					</div>
				)}
				<div className="col-span-full">
					<RenderModules modules={[...modules, ...globalPdpModules]} productId={id} className="max-w-screen-xl mx-auto" />
				</div>
			</div>

			<ProductRichSnippet product={product} />

		</BaseLayout>
	);
};

export default PDP;
